import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6762f7eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "fs-tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "fs-search-wrap" }
const _hoisted_6 = ["onMousedown"]
const _hoisted_7 = {
  key: 0,
  class: "fs-tab-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FactorDescDialog = _resolveComponent("FactorDescDialog")!
  const _component_FactorGroup = _resolveComponent("FactorGroup")!

  return (_openBlock(), _createElementBlock("div", {
    class: "factor-selector",
    style: _normalizeStyle({ color: _ctx.colors.textPrimary })
  }, [
    _createElementVNode("div", {
      class: "fs-left",
      style: _normalizeStyle({ borderColor: _ctx.isLight ? '#dbdfe6' : '#3D3D3D', border: _ctx.isLight ? '1px solid #dbdfe6' : '1px solid #3D3D3D' })
    }, [
      _createElementVNode("div", {
        class: "fs-left-title",
        style: _normalizeStyle({ color: _ctx.colors.textPrimary, background: _ctx.isLight ? '#f0f2f5' : '#3D3D3D', borderBottomColor: _ctx.isLight ? '#dbdfe6' : '#2a2a2a' })
      }, "当前已选（" + _toDisplayString(_ctx.selectedFactors.length) + "）", 5),
      _createElementVNode("div", {
        class: "fs-left-list",
        style: _normalizeStyle({ background: _ctx.isLight ? '#ffffff' : '#262626' })
      }, [
        (_ctx.selectedFactors.length === 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fs-empty",
              style: _normalizeStyle({ color: _ctx.colors.textMuted })
            }, " 暂未选择因子 ", 4))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFactors, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.attrCode,
            class: "fs-selected-item"
          }, [
            _createElementVNode("span", {
              class: "fs-selected-name",
              style: _normalizeStyle({ color: _ctx.colors.textPrimary })
            }, _toDisplayString(_ctx.formatSelectedLabel(item)), 5),
            _createElementVNode("span", {
              class: "fs-selected-remove",
              onClick: ($event: any) => (_ctx.removeSelected(item))
            }, "⊗", 8, _hoisted_1)
          ]))
        }), 128))
      ], 4)
    ], 4),
    _createElementVNode("div", {
      class: "fs-right",
      style: _normalizeStyle({ borderColor: _ctx.colors.border })
    }, [
      _createElementVNode("div", {
        class: "fs-tabs-row",
        style: _normalizeStyle({ borderBottomColor: _ctx.colors.border })
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.factorTree, (tab) => {
            return (_openBlock(), _createElementBlock("span", {
              key: tab.attrCode,
              class: _normalizeClass(["fs-tab", { active: _ctx.activeTab === tab.attrCode }]),
              style: _normalizeStyle(_ctx.activeTab !== tab.attrCode ? { background: _ctx.isLight ? '#f0f0f0' : '#2a2a2a', color: _ctx.isLight ? '#999' : '#888' } : {}),
              onClick: ($event: any) => (_ctx.activeTab = tab.attrCode)
            }, [
              _createTextVNode(_toDisplayString(tab.attrName) + " ", 1),
              (_ctx.tabHasDesc(tab))
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "fs-tab-help",
                    onClick: _withModifiers(($event: any) => (_ctx.openDescDialog(tab)), ["stop"])
                  }, "?", 8, _hoisted_4))
                : _createCommentVNode("", true)
            ], 14, _hoisted_3))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchKeyword) = $event)),
            class: "fs-search-input",
            style: _normalizeStyle({ background: _ctx.isLight ? '#f5f5f5' : '#252525', color: _ctx.colors.textPrimary, borderColor: _ctx.colors.border }),
            placeholder: "搜索因子，如市盈率、涨跌幅",
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args))),
            onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDropdown = true)),
            onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args)))
          }, null, 36), [
            [_vModelText, _ctx.searchKeyword]
          ]),
          (_ctx.showDropdown && _ctx.searchResults.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fs-dropdown",
                style: _normalizeStyle({ background: _ctx.isLight ? '#fff' : '#252525', borderColor: _ctx.colors.border })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.attrCode,
                    class: "fs-dropdown-item",
                    style: _normalizeStyle({ color: _ctx.colors.textPrimary }),
                    onMousedown: _withModifiers(($event: any) => (_ctx.selectFromSearch(item)), ["prevent"])
                  }, [
                    _createElementVNode("span", null, _toDisplayString(item.attrName), 1),
                    _createElementVNode("span", {
                      class: "fs-dropdown-tag",
                      style: _normalizeStyle({ color: _ctx.colors.textMuted })
                    }, _toDisplayString(item.rootName), 5)
                  ], 44, _hoisted_6))
                }), 128))
              ], 4))
            : _createCommentVNode("", true)
        ])
      ], 4),
      _createVNode(_component_FactorDescDialog, {
        visible: _ctx.showDescDialog,
        "tab-node": _ctx.descDialogTab,
        "is-light": _ctx.isLight,
        colors: _ctx.colors,
        onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDescDialog = false))
      }, null, 8, ["visible", "tab-node", "is-light", "colors"]),
      (_ctx.currentTab)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_FactorGroup, {
              group: _ctx.currentTab,
              "selected-codes": _ctx.selectedCodes,
              "selected-map": _ctx.selectedMap,
              "is-light": _ctx.isLight,
              colors: _ctx.colors,
              headers: _ctx.headers,
              "highlight-code": _ctx.highlightCode,
              onToggle: _ctx.onToggleFactor,
              onOpenDesc: _ctx.openDescDialog
            }, null, 8, ["group", "selected-codes", "selected-map", "is-light", "colors", "headers", "highlight-code", "onToggle", "onOpenDesc"])
          ]))
        : _createCommentVNode("", true)
    ], 4)
  ], 4))
}